// utils/weatherIcons.js
import {
  faTemperatureHigh,
  faTint,
  faWind,
  faCloud,
  faSun,
  faEye,
  faCloudRain,
  faCalendarAlt,
  faMoon,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faClock,
  faTemperatureLow,
} from "@fortawesome/free-solid-svg-icons";

export const getWindDirectionIcon = (degrees) => {
  if (degrees >= 337.5 || degrees < 22.5) return faArrowDown;
  if (degrees >= 22.5 && degrees < 67.5) return faArrowDown;
  if (degrees >= 67.5 && degrees < 112.5) return faArrowLeft;
  if (degrees >= 112.5 && degrees < 157.5) return faArrowLeft;
  if (degrees >= 157.5 && degrees < 202.5) return faArrowUp;
  if (degrees >= 202.5 && degrees < 247.5) return faArrowUp;
  if (degrees >= 247.5 && degrees < 292.5) return faArrowRight;
  if (degrees >= 292.5 && degrees < 337.5) return faArrowRight;
  return faWind;
};

export const getWindDirectionText = (degrees) => {
  if (degrees >= 337.5 || degrees < 22.5) return "N";
  if (degrees >= 22.5 && degrees < 67.5) return "NE";
  if (degrees >= 67.5 && degrees < 112.5) return "E";
  if (degrees >= 112.5 && degrees < 157.5) return "SE";
  if (degrees >= 157.5 && degrees < 202.5) return "S";
  if (degrees >= 202.5 && degrees < 247.5) return "SW";
  if (degrees >= 247.5 && degrees < 292.5) return "W";
  if (degrees >= 292.5 && degrees < 337.5) return "NW";
  return "";
};

export const weatherIcons = {
  temperature: faTemperatureHigh,
  tempLow: faTemperatureLow,
  humidity: faTint,
  wind: faWind,
  cloud: faCloud,
  sun: faSun,
  visibility: faEye,
  rain: faCloudRain,
  calendar: faCalendarAlt,
  moon: faMoon,
  clock: faClock,
};
